import React from "react";
import "style/Contact.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import { Col, Row, Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModalDropdown from "components/ModalDropdown";

import { default as SvgHeaderTitle } from "assets/SvgHeaderTitle.svg";
import { default as SvgHeaderNavigation } from "assets/SvgHeaderNavigation.svg";
import { default as SvgHeaderNavigationClose } from "assets/SvgHeaderNavigationClose.svg";
import { default as SvgChangeLanguage } from "assets/icon_lang.svg";

import en from "../config/i18n/english/english";
import de from "../config/i18n/german/german";

interface Props {}

interface State {
  dropdown: boolean;

  language: any;
  dropdownLanguage: boolean;
}

class Contact extends React.Component<{}, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      dropdown: false,
      language: en,
      dropdownLanguage: false,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem("lang") === null) {
      const browserLanguage = navigator.language.split("-")[0];
      this.setState({
        language: browserLanguage === "de" ? de : en,
      });
    } else {
      this.setState({
        language: sessionStorage.getItem("lang") === "de" ? de : en,
      });
    }

    window.addEventListener("scroll", (e) => this.handleScrollPositionEvent(e));

    return () => {
      window.removeEventListener("scroll", (e) =>
        this.handleScrollPositionEvent(e)
      );
    };
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  handleScrollPositionEvent(e: any) {
    this.setState({ dropdownLanguage: false });
    this.setState({ dropdown: false });
  }

  render() {
    const { language } = this.state;

    return (
      <>
        <ModalDropdown
          showDropdown={this.state.dropdown}
          showDropdownLanguage={this.state.dropdownLanguage}
          contact={this.state.dropdown}
        />
        <div className="header-contact">
          <Container
            fluid={true}
            className="p-0 container-title-dropdown container-logo-dropdown"
          >
            <Row className="g-0">
              <Col className="svg-header-title">
                <Link to="/">
                  <img
                    src={SvgHeaderTitle}
                    className="svgHeaderTitle"
                    alt="svg header"
                  />
                </Link>
              </Col>

              <Col className="dropdown text-end">
                <Button
                  onClick={() => {
                    this.setState({
                      dropdown: false,
                      dropdownLanguage: !this.state.dropdownLanguage,
                    });
                  }}
                >
                  {this.state.dropdownLanguage ? (
                    <img
                      src={SvgHeaderNavigationClose}
                      className="svg-dropdown svg-change-language"
                      alt="Dropdown"
                    />
                  ) : (
                    <img
                      src={SvgChangeLanguage}
                      className="svg-dropdown svg-change-language"
                      alt="Dropdown"
                    />
                  )}
                </Button>

                <Button
                  onClick={() => {
                    this.setState({
                      dropdownLanguage: false,
                      dropdown: !this.state.dropdown,
                    });
                  }}
                >
                  {this.state.dropdown ? (
                    <img
                      src={SvgHeaderNavigationClose}
                      className="svg-dropdown"
                      alt="Dropdown"
                    />
                  ) : (
                    <img
                      src={SvgHeaderNavigation}
                      className="svg-dropdown"
                      alt="Dropdown"
                    />
                  )}
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="body-contact">
          <h4>{language.contact.contactHeader}</h4>
          <p>{/*language.contact.contactContent*/}</p>
	  <strong>Company name:</strong><br/>
          MARKSIM SERVICES GMBH<br/>
	  1220 VIENNA, AUSTRIA, EU<br/>
	  Oberdorfstrasse 9/1<br/><br/>
	  <strong>Commercial register:</strong> FN461691h<br/>
	  <strong>VAT:</strong> AT U71709001<br/>
          <strong>GLN:</strong> 9110024112908<br/><br/>

          <strong>Phone:</strong> +43 1 205 108 525-0<br/>
	  <strong>Email:</strong> contact@marksim.org<br/><br/>
	  <strong>Court of jurisdiction:</strong><br/>
	  Handelsgericht Wien (Commercial Court, Vienna)<br/><br/>
	  Please find our detailed company data here: <a href="https://firmen.wko.at/marksim-services-gmbh/wien/?firmaid=a8ed2291-a55d-4e6d-8c7b-ad83a4caea0f&suchbegriff=marksim">Commercial Chamber of Austria (WKO)</a>
        </div>
      </>
    );
  }
}

export default Contact;
